// extracted by mini-css-extract-plugin
export default {"container":"InventoryAdd_container__-PkHF","menuBar":"InventoryAdd_menuBar__nF9z2","menuBtn":"InventoryAdd_menuBtn__jhmO1","active":"InventoryAdd_active__tzQbq"};